import { useEffect, useState } from "react";
import { MessageSquareText, RefreshCw, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import api from "@/lib/api";

const RANGES = [[7, "7 giorni"], [30, "30 giorni"]];

export function AiFaqCard() {
  const [days, setDays] = useState(7);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async (refresh = false) => {
    setBusy(true);
    try { setData(await api.waAiFaq(days, refresh)); } catch { toast.error("Statistiche agente IA non disponibili"); } finally { setBusy(false); }
  };
  useEffect(() => { load(); }, [days]); // eslint-disable-line react-hooks/exhaustive-deps
  const max = Math.max(1, ...(data?.faq || []).map((f) => f.count));
  return (
    <Card className="p-5 bg-card border-border space-y-3" data-testid="whatsapp-ai-faq">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h3 className="font-display font-bold text-lg flex items-center gap-2"><MessageSquareText className="h-4 w-4" /> Domande più frequenti all'agente IA</h3>
        <div className="flex items-center gap-1.5">
          {RANGES.map(([d, l]) => (
            <button key={d} type="button" onClick={() => setDays(d)} data-testid={`ai-faq-range-${d}`}
              className={`rounded-full border px-2.5 py-0.5 text-[11px] transition-colors ${days === d ? "bg-primary/10 text-primary border-primary/40 font-semibold" : "border-border text-muted-foreground hover:text-foreground"}`}>{l}</button>
          ))}
          <Button size="sm" variant="secondary" className="h-8" disabled={busy} onClick={() => load(true)} title="Ricalcola con l'IA" data-testid="ai-faq-refresh"><RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} /></Button>
          <Button size="sm" variant="outline" className="h-8 gap-1.5 text-xs" asChild data-testid="ai-faq-export"><a href={api.waAiFaqExportUrl(days)} download><FileSpreadsheet className="h-3.5 w-3.5" /> Excel</a></Button>
        </div>
      </div>
      {data && (
        <>
          <div className="grid grid-cols-3 gap-2">
            {[["Domande gestite", data.messages, "ai-faq-kpi-messages"], ["Conversazioni", data.conversations, "ai-faq-kpi-conversations"], ["Passaggi a operatore", data.handoffs, "ai-faq-kpi-handoffs"]].map(([l, v, t]) => (
              <div key={t} className="rounded-lg bg-secondary/40 p-3" data-testid={t}><div className="text-[11px] text-muted-foreground">{l}</div><div className="font-display font-bold text-xl">{v}</div></div>
            ))}
          </div>
          {data.faq.length === 0 ? (
            <p className="text-sm text-muted-foreground" data-testid="ai-faq-empty">Nessuna domanda gestita dall'agente IA nel periodo.</p>
          ) : (
            <ul className="space-y-2" data-testid="ai-faq-list">
              {data.faq.map((f, i) => (
                <li key={f.topic} className="space-y-1" data-testid={`ai-faq-item-${i}`}>
                  <div className="flex items-center justify-between text-sm"><span className="font-semibold">{i + 1}. {f.topic}</span><span className="text-muted-foreground text-xs">{f.count} {f.count === 1 ? "domanda" : "domande"}</span></div>
                  <div className="h-2 rounded-full bg-secondary overflow-hidden"><div className="h-full rounded-full bg-[var(--nc-blue)] transition-[width]" style={{ width: `${Math.round((f.count / max) * 100)}%` }} /></div>
                  {f.example && <p className="text-xs text-muted-foreground italic">“{f.example}”</p>}
                </li>
              ))}
            </ul>
          )}
          <p className="text-[11px] text-muted-foreground">Argomenti raggruppati dall'IA sulle domande ricevute negli ultimi {data.days} giorni · aggiornato {new Date(data.generated_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}.</p>
        </>
      )}
    </Card>
  );
}
